import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { HISTORY_EMPTY_MESSAGE } from '../lib/history-copy'
import { historyEmptyMessageSx, historyEmptyWrapSx } from '../styles/historyStyles'
import emptyIllustration from '../assets/history-empty-illustration.png'

export function SurveyHistoryEmptyState() {
  return (
    <Box sx={historyEmptyWrapSx} data-testid="history-empty-state">
      <Box
        component="img"
        src={emptyIllustration}
        alt=""
        sx={{ width: 240, height: 240, objectFit: 'contain' }}
      />
      <Typography sx={historyEmptyMessageSx}>{HISTORY_EMPTY_MESSAGE}</Typography>
    </Box>
  )
}
